import { type FunctionComponent, type ReactElement, type ReactNode } from 'react';
import { Cell, type CellProps, Text, VStack } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components/testing';

export interface CellStatusProps extends TestProps, Omit<CellProps, 'type' | 'children'> {
    label: ReactElement;
    caption?: string | ReactNode;
    errorText?: string;
    errorClassName?: string;
}

export const CellLabel: FunctionComponent<CellStatusProps> = ({
    'data-testid': dataTestId = 'CellStatus',
    label,
    caption,
    errorText,
    errorClassName,
    ...props
}) => (
    <Cell type="Label" data-testid={dataTestId} {...props}>
        <VStack gap="4" alignItems="flex-start" justifyContent="flex-start">
            {label}
            {caption &&
                (typeof caption === 'string' ? (
                    <Text size="xs" role="supplementary">
                        {caption}
                    </Text>
                ) : (
                    caption
                ))}
            {errorText && (
                <Text size="xs" color="red" className={errorClassName}>
                    {errorText}
                </Text>
            )}
        </VStack>
    </Cell>
);
